import React from "react";
import { Card, Divider } from "antd";
import dayjs from "dayjs"; // Đảm bảo bạn đã cài dayjs để xử lý ngày tháng
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/vi";

dayjs.extend(relativeTime);
dayjs.locale("vi");

const NewsContent = ({ newDetail }: any) => {
  if (!newDetail) {
    return <div>Loading...</div>; // Nếu newDetail chưa có, hiển thị Loading
  }

  // Kiểm tra các thuộc tính của newDetail có hợp lệ không
  const { title, updated_at, tokens, content } = newDetail;

  // Kiểm tra dữ liệu để tránh lỗi
  if (!title || !updated_at || !content) {
    return <div>Error: Missing required data</div>; // Nếu thiếu dữ liệu quan trọng
  }

  return (
    <div style={{ padding: "10px" }}>
      {/* Tiêu đề */}
      <div style={{ fontWeight: 600, fontSize: 18, marginBottom: 16 }}>
        {title}
      </div>

      {/* Dòng 2: Thời gian và Danh sách coin */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 16,
        }}
      >
        {/* Thời gian cập nhật */}
        <div style={{ color: "#1677ff", fontSize: 12 }}>
          {(() => {
            const tokenstr = tokens.replace(/^,|,$/g, "").trim();
            return tokenstr.length > 20
              ? tokenstr.slice(0, 20) + "..."
              : tokenstr;
          })()}
        </div>

        {/* Danh sách coin */}
        <div style={{ color: "#999", fontSize: 12 }}>
          {dayjs(updated_at).fromNow()}
        </div>
      </div>

      {/* Nội dung bài viết */}
      <div style={{ fontSize: 14, lineHeight: "1.6", whiteSpace: "pre-line" }}>
        {content}
      </div>
    </div>
  );
};

export default NewsContent;
